import { render, staticRenderFns } from "./BiteEditModal.vue?vue&type=template&id=00d4eb4f&scoped=true"
import script from "./BiteEditModal.vue?vue&type=script&lang=js"
export * from "./BiteEditModal.vue?vue&type=script&lang=js"
import style0 from "./BiteEditModal.vue?vue&type=style&index=0&id=00d4eb4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d4eb4f",
  null
  
)

export default component.exports